export const SUPER_SOUND_ADMIN_EMAIL = "abitbolrotem@gmail.com";

export function normalizeSuperSoundEmail(email) {
  if (!email) return "";
  return email.trim().toLowerCase();
}

export function isSuperSoundAdmin(email) {
  return normalizeSuperSoundEmail(email) === SUPER_SOUND_ADMIN_EMAIL;
}

export function superSoundAccessDocId(email) {
  return normalizeSuperSoundEmail(email);
}

export function hasSuperSoundLibraryAccessSync(email) {
  return isSuperSoundAdmin(email);
}

export async function userHasSuperSoundAccess(email, getAccessDoc) {
  if (hasSuperSoundLibraryAccessSync(email)) return true;
  const docId = superSoundAccessDocId(email);
  if (!docId) return false;
  try {
    const snap = await getAccessDoc(docId);
    return snap.exists();
  } catch {
    return false;
  }
}

export function isValidEmailForAccess(email) {
  const normalized = normalizeSuperSoundEmail(email);
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized);
}
